import { observable, configure, action } from 'mobx';
import LocalModel from './localModel';

import util from 'preact-util';

configure({ enforceActions: 'always' });

class CoffeeStore extends LocalModel {
    constructor() {
        super('coffee', {
            namePlural: 'coffees',
            sort: '-createdDate',
            limit: 100,
            api: {
                search: {
                    url: '/api/coffees/',
                    params: {
                        limit: 100,
                        sort: '-createdDate',
                    },
                },
                load: {
                    url: '/api/coffees/',
                    params: {},
                },
                save: {
                    url: '/api/coffees/',
                    params: {},
                },
                delete: {
                    url: '/api/coffees/',
                    params: {},
                },
            },
        });
    }

    @observable total = 0;

    @observable limit = 100;

    @observable offset = 0;

    @observable currentPage = 1;

    @observable newCoffee = {};

    @observable coffee = {};

    @observable coffees = [];

    @observable searchResults = [];

    @observable stats = {};

    @observable extractedData = {};

    @observable originalExtractedData = {};

    @observable normalizations = [];

    @observable isExtracting = false;

    @action
    async loadStats() {
        const response = await util.fetchApi('/api/coffees/stats', { method: 'GET' });
        if (response?.status === 200) {
            this.updateKeyValue('stats', response.data || {});
        }
        return response;
    }

    @action
    async extractFromImage(imageBase64) {
        this.updateKeyValue('isExtracting', true);
        this.updateKeyValue('extractedData', {});
        this.updateKeyValue('originalExtractedData', {});
        this.updateKeyValue('normalizations', []);

        try {
            const response = await util.fetchApi('/api/coffees/extract-from-image', { method: 'POST' }, {
                imageBase64,
            });

            if (response?.status === 200) {
                const { coffee, original, normalizations = [] } = response.data || {};
                this.updateKeyValue('extractedData', coffee || {});
                this.updateKeyValue('originalExtractedData', original || {});
                this.updateKeyValue('normalizations', normalizations);
                return {
                    coffee,
                    original,
                    normalizations,
                };
            }
            return null;
        } finally {
            this.updateKeyValue('isExtracting', false);
        }
    }

    @action
    async extractFromImageUrl(imageUrl, coffeeId = null) {
        this.updateKeyValue('isExtracting', true);
        this.updateKeyValue('extractedData', {});
        this.updateKeyValue('originalExtractedData', {});
        this.updateKeyValue('normalizations', []);

        try {
            const body = { imageUrl };
            if (coffeeId) {
                body.id = coffeeId;
            }

            const response = await util.fetchApi('/api/coffees/extract-from-image', { method: 'POST' }, body);

            if (response?.status === 200) {
                const { coffee, original, normalizations = [], saved = false } = response.data || {};
                this.updateKeyValue('extractedData', coffee || {});
                this.updateKeyValue('originalExtractedData', original || {});
                this.updateKeyValue('normalizations', normalizations);
                return {
                    coffee,
                    original,
                    normalizations,
                    saved,
                };
            }
            return null;
        } finally {
            this.updateKeyValue('isExtracting', false);
        }
    }

    @action
    clearExtractedData() {
        this.updateKeyValue('extractedData', {});
        this.updateKeyValue('originalExtractedData', {});
        this.updateKeyValue('normalizations', []);
    }

    @action
    applyExtractedData() {
        // Merge extracted data with newCoffee
        const merged = {
            ...this.newCoffee,
            ...this.extractedData,
        };
        this.updateKeyValue('newCoffee', merged);
    }
}

const store = new CoffeeStore();
export default store;
